import { filterName } from "../utils";

export const applyAllEntitiesFilters = (entities, appliedFilters) => {
  let filteredEntities = [...entities];

  // Entity Type
  if (
    filterName.ENTITY_TYPE in appliedFilters &&
    Object.keys(appliedFilters[filterName.ENTITY_TYPE]).length > 0
  ) {
    const checkedEntityTypes = Object.keys(
      appliedFilters[filterName.ENTITY_TYPE]
    ).filter(
      (entityType) => appliedFilters[filterName.ENTITY_TYPE][entityType]
    );
    if (checkedEntityTypes.length > 0)
      filteredEntities = filteredEntities.filter((entity) =>
        checkedEntityTypes.includes(entity?.entity_type)
      );
  }

  entities.length = 0;
  for (let i = 0; i < filteredEntities.length; i++) {
    entities[i] = filteredEntities[i];
  }
};
